import {Flex, Text} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';

import {CaptainIcon, ViceCaptainIcon} from './icons';

interface RoleIndicatorProps {
  role: 'captain' | 'vice-captain';
}

export const RoleIndicator = ({role}: RoleIndicatorProps) => {
  const t = useTranslate();

  return (
    <Flex flexDir="column" align="flex-end">
      {role === 'captain' ? <CaptainIcon boxSize="5" /> : <ViceCaptainIcon boxSize="5" />}

      <Text as="span" color={role === 'captain' ? 'gold' : 'silver'} fontSize="x-small" fontWeight="700">
        {t(`fantasy.lineup.player.actions.${role}`)}
      </Text>
    </Flex>
  );
};
